import Select from "react-select";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import useBulkUpload, { TYPE_OPTIONS } from "./useBulkUpload";
import Style from "../menuThumbnails.module.scss";

// Bulk upload of menu thumbnail images (see useBulkUpload)

const BulkUpload = ({ refetch, handleClose }) => {
  const {
    fileInputRef,
    type,
    typeError,
    items,
    progress,
    isUploading,
    acceptTypes,
    handleTypeChange,
    handleFileChange,
    handleRemove,
    handleUpload,
    handleCancel,
  } = useBulkUpload({ refetch, handleClose });

  return (
    <div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="menu_thumbnail_type" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Type*
        </label>
        <Select
          id="menu_thumbnail_type"
          placeholder={"Select"}
          className={`pro-input lg ${typeError ? "error" : ""}`}
          classNamePrefix="pro-input"
          options={TYPE_OPTIONS}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.label}
          value={type}
          onChange={handleTypeChange}
          isDisabled={isUploading}
        />
        {typeError && <span className="error-text">{typeError}</span>}
      </div>

      <div className="input-wrap pro-mb-4">
        <label className="pro-font-sm pro-mb-1 pro-fw-medium">
          {type ? `${type.label} Thumbnails*` : "Thumbnails*"}
        </label>
        <label
          htmlFor="menu_thumbnail_files"
          className={`${Style.drop_zone} ${!type || isUploading ? Style.disabled : ""}`}
        >
          <span className="material-symbols-outlined">add_photo_alternate</span>
          <span className="pro-fw-medium">
            {type ? `Click to select ${type.label.toLowerCase()} images` : "Select a type first"}
          </span>
          <span className="pro-font-xs pro-opacity-60">JPG, JPEG, PNG or WEBP, up to 5 MB each</span>
          <input
            type="file"
            multiple
            ref={fileInputRef}
            accept={acceptTypes}
            id="menu_thumbnail_files"
            className={Style.file_input}
            onChange={handleFileChange}
            disabled={!type || isUploading}
          />
        </label>
      </div>

      {items.length > 0 && (
        <>
          <p className="pro-font-sm pro-mb-2">{items.length} image(s) selected</p>
          <div className={Style.preview_grid}>
            {items.map((item) => (
              <div key={item.id} className={Style.preview}>
                <img src={item.preview} alt={item.title} />
                <p className="pro-mb-0 pro-font-xs" title={item.name}>
                  {item.name}
                </p>
                {!isUploading && (
                  <button
                    type="button"
                    className={Style.remove_btn}
                    onClick={() => handleRemove(item.id)}
                    aria-label={`Remove ${item.name}`}
                  >
                    <span className="material-symbols-outlined">close</span>
                  </button>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {isUploading && (
        <div className={`pro-mt-4 ${Style.progress}`}>
          <span style={{ width: `${progress}%` }} />
          <em>Uploading {progress}%</em>
        </div>
      )}

      <div className="col-12 pro-mt-4 pro-d-flex pro-justify-end">
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCancel}
          type="button"
          disabled={isUploading}
        >
          Cancel
        </Button>
        <Button
          className={"pro-btn-primary lg pro-mx-3"}
          type="button"
          onClick={handleUpload}
          disabled={isUploading || items.length === 0}
        >
          {isUploading ? "Uploading..." : `Upload${items.length ? ` (${items.length})` : ""}`}
        </Button>
      </div>
    </div>
  );
};

export default BulkUpload;
